type BrandLogoProps = {
  className?: string;
  textClassName?: string;
};

export function BrandLogo({ className, textClassName }: BrandLogoProps) {
  return (
    <div
      className={className ?? "inline-flex items-center gap-2"}
      aria-label="Atten Newline logo"
    >
      <svg
        width="40"
        height="40"
        viewBox="0 0 132.29167 119.0625"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0"
      >
        <path
          fill="currentColor"
          d="M 38.185397,2.2749648e-5 -1.4333334e-7,66.164303 40.682231,89.660601 l -1.1e-5,29.401899 25.460751,-14.6981 0.0056,-0.006 L 91.603543,89.660795 40.682231,60.25299 84.783281,34.786244 110.23827,78.897678 132.29167,66.164303 94.100549,7.4999999e-7 66.142984,16.147287 Z"
        />
      </svg>
      <span
        className={
          textClassName ?? "font-mono text-2xl font-semibold leading-none"
        }
      >
        Newline
      </span>
    </div>
  );
}
